import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredBoolean,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createInvoicingProductsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        name: requiredString().min(1),
        price: requiredString().min(1),
        available: requiredBoolean(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
    });

export const createInvoicingProductsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createInvoicingProductsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.invoicing_products,
    );

export const createInvoicingProductsDeleteSchema = () => createDeleteSchema();

export const createInvoicingProductsSchemas = () => ({
    add: createInvoicingProductsAddSchema(),
    update: createInvoicingProductsUpdateSchema(),
    delete: createInvoicingProductsDeleteSchema(),
});
